__turbopack_context__.v({
  "Blank": "frJayG_Blank",
  "BlueGreen": "frJayG_BlueGreen",
  "Blurb": "frJayG_Blurb",
  "Hide": "frJayG_Hide",
  "MarginBottom": "frJayG_MarginBottom",
  "PinkBlue": "frJayG_PinkBlue",
  "PinkOrange": "frJayG_PinkOrange",
  "PinkPurple": "frJayG_PinkPurple",
  "PurpleBlue": "frJayG_PurpleBlue",
  "Root": "frJayG_Root",
  "TitleBottom": "frJayG_TitleBottom",
  "TitleTop": "frJayG_TitleTop",
  "UspSlider": "frJayG_UspSlider",
  "backgroundChange": "frJayG_backgroundChange",
  "backgroundChangeBack": "frJayG_backgroundChangeBack",
  "black-glass": "frJayG_black-glass",
  "container": "frJayG_container",
  "fadeIn": "frJayG_fadeIn",
  "grid": "frJayG_grid",
  "rich-card-title": "frJayG_rich-card-title",
  "white-glass": "frJayG_white-glass",
});
